var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorSmartObject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 80,
    viewBox: "0 0 85 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 85,
    height: 80,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M429.7,2409a1.7,1.7,0,0,1,0-3.4h3.4v-69.782a1.7,1.7,0,0,1,1.7-1.7h37.4a1.7,1.7,0,0,1,1.7,1.7V2405.6h6.8v-74.888a1.7,1.7,0,0,1,2.551-1.48l23.8,13.616a1.706,1.706,0,0,1,.85,1.48V2405.6h3.4a1.7,1.7,0,0,1,0,3.4Zm74.8-3.4V2345.31l-20.4-11.666V2405.6Zm-34,0v-68.081h-34V2405.6h6.8v-18.722a1.7,1.7,0,0,1,1.7-1.7h17a1.7,1.7,0,0,1,1.7,1.7V2405.6Zm-10.2,0v-17.02H446.7v17.02Zm28.9-13.616a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm0-10.212a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm44.2-6.808a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm44.2-6.808a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm44.2-6.809a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(-428 -2329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-3",
    "data-name": "Vector Smart Object",
    transform: "translate(428 2329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M17,49.364h5.1a1.7,1.7,0,0,0,0-3.4H17a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M28.9,49.364H34a1.7,1.7,0,0,0,0-3.4H28.9a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M17,39.152h5.1a1.7,1.7,0,0,0,0-3.4H17a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M28.9,39.152H34a1.7,1.7,0,0,0,0-3.4H28.9a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M17,28.94h5.1a1.7,1.7,0,0,0,0-3.4H17a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M28.9,28.94H34a1.7,1.7,0,0,0,0-3.4H28.9a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M18.7,59.576H32.3V76.6H18.7ZM8.5,8.516h34V76.6H35.7V57.874a1.7,1.7,0,0,0-1.7-1.7H17a1.7,1.7,0,0,0-1.7,1.7V76.6H8.5ZM56.1,4.644,76.5,16.31V76.6H56.1ZM83.3,76.6H79.9V15.324a1.7,1.7,0,0,0-.849-1.48L55.251.228A1.7,1.7,0,0,0,52.7,1.708V76.6H45.9V6.814a1.7,1.7,0,0,0-1.7-1.7H6.8a1.7,1.7,0,0,0-1.7,1.7V76.6H1.7a1.7,1.7,0,0,0,0,3.4H83.3a1.7,1.7,0,0,0,0-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M17,18.728h5.1a1.7,1.7,0,0,0,0-3.4H17a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M28.9,18.728H34a1.7,1.7,0,0,0,0-3.4H28.9a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M66.3,49.364H61.2a1.7,1.7,0,0,0,0,3.4h5.1a1.7,1.7,0,0,0,0-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M66.3,39.152H61.2a1.7,1.7,0,0,0,0,3.4h5.1a1.7,1.7,0,0,0,0-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M66.3,28.94H61.2a1.7,1.7,0,0,0,0,3.4h5.1a1.7,1.7,0,0,0,0-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M61.2,22.132h5.1a1.7,1.7,0,0,0,0-3.4H61.2a1.7,1.7,0,0,0,0,3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M66.3,59.576H61.2a1.7,1.7,0,0,0,0,3.4h5.1a1.7,1.7,0,0,0,0-3.4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M429.7,2409a1.7,1.7,0,0,1,0-3.4h3.4v-69.782a1.7,1.7,0,0,1,1.7-1.7h37.4a1.7,1.7,0,0,1,1.7,1.7V2405.6h6.8v-74.888a1.7,1.7,0,0,1,2.551-1.48l23.8,13.616a1.706,1.706,0,0,1,.85,1.48V2405.6h3.4a1.7,1.7,0,0,1,0,3.4Zm54.4-3.4h20.4V2345.31l-20.4-11.666ZM462,2385.172a1.7,1.7,0,0,1,1.7,1.7V2405.6h6.8v-68.081h-34V2405.6h6.8v-18.722a1.7,1.7,0,0,1,1.7-1.7ZM446.7,2405.6h13.6v-17.02H446.7Zm42.5-13.616a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm0-10.212a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm44.2-6.808a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm44.2-6.808a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm44.2-6.809a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Zm-32.3-3.4a1.7,1.7,0,0,1,0-3.4H462a1.7,1.7,0,0,1,0,3.4Zm-11.9,0a1.7,1.7,0,0,1,0-3.4h5.1a1.7,1.7,0,0,1,0,3.4Z",
    fill: "#82decf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorSmartObject);
export default __webpack_public_path__ + "static/media/Vector Smart Object.7c956119741a5087394da7fa46bd2c2b.svg";
export { ForwardRef as ReactComponent };